import { z } from "zod";

export const baseTimeDataPointSchema = z.object({
	year: z.number(),
	month: z.number(),
	day: z.number(),
	hour: z.number().optional(),
	minute: z.number().optional(),
	week: z.number().optional(),
	isPartial: z.boolean().optional(),
});

const cartonProductionTimeDataSchema = baseTimeDataPointSchema.extend({
	cartonsProduced: z.number(),
	cartonsUnsuccesful: z.number().optional(), // Note: API has typo
	isoWeek: z.number().optional(),
	isoYear: z.number().optional(),
});

const cartonProductionByZFoldSchema = z.object({
	tenantId: z.string().optional(),
	cartonsProduced: z.number(),
	corrugateAlias: z.string(),
	corrugateWidth: z.number(),
	corrugateBrand: z.string().optional(),
	corrugateFlute: z.string().optional(),
	percentage: z.number().optional(),
	siteName: z.string().optional(),
});

const cartonProductionByMachineSchema = z.object({
	machineName: z.string(),
	cartonsProduced: z.number(),
	cartonsFailed: z.number().optional(),
	percentage: z.number().optional(),
});

export const cartonProductionResponseSchema = z.object({
	totalCartonsProduced: z.number(),
	totalCartonsUnsuccessful: z.number(),
	averageProductionTime: z.number(),
	byZFold: z.array(cartonProductionByZFoldSchema),
	byMachine: z.array(cartonProductionByMachineSchema),
	overTime: z.array(
		z.object({
			machineName: z.string(),
			machineId: z.string(),
			data: z.array(cartonProductionTimeDataSchema),
		}),
	),
	isScheduleApplied: z.boolean().optional(),
});

export type CartonProductionTimeData = z.infer<typeof cartonProductionTimeDataSchema>;
export type CartonProductionByZFold = z.infer<typeof cartonProductionByZFoldSchema>;
export type CartonProductionApiResponse = z.infer<typeof cartonProductionResponseSchema>;

export const DEFAULT_CARTON_PRODUCTION_API_RESPONSE: CartonProductionApiResponse = {
	totalCartonsProduced: 0,
	totalCartonsUnsuccessful: 0,
	averageProductionTime: 0,
	byZFold: [],
	byMachine: [],
	overTime: [],
};

export type CartonProductionNavigation = "" | "producedByZFold" | "producedByMachine";
